import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
export default function ConteudosPage() {
  const { t } = useTranslation('conteudos');

  const articles = t('articles', { returnObjects: true }) as Array<{
    category: string;
    title: string;
    excerpt: string;
    date: string;
    readTime: string;
  }>;

  return (
    <div className="min-h-screen bg-[#F6F2EC]">

      {/* Hero */}
      <section className="relative min-h-[65vh] flex items-end overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0 w-full h-full">
          <img
            src="https://public.readdy.ai/ai/img_res/79a205b60bca2a2f08b63e1608a4e470.jpg"
            alt="Conteúdos FGT"
            className="w-full h-full object-cover object-top"
          />
        </div>
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B0B0B]/90 via-[#0B0B0B]/45 to-[#0B0B0B]/10"></div>
        {/* Accent line */}
        <div className="absolute bottom-0 left-0 right-0 h-[3px] bg-[#F97700]"></div>

        {/* Content */}
        <div className="relative z-10 w-full max-w-7xl mx-auto px-6 pb-20 pt-48">
          <div className="max-w-3xl">
            <p className="text-xs font-semibold tracking-[0.25em] uppercase text-[#F97700] mb-6">
              {t('hero.label')}
            </p>
            <h1 className="text-5xl md:text-7xl font-semibold text-white leading-[1.05] mb-8 drop-shadow-lg">
              {t('hero.title')}
            </h1>
            <p className="text-xl text-white/80 leading-relaxed max-w-2xl">
              {t('hero.subtitle')}
            </p>
          </div>
        </div>
      </section>

      {/* Articles Grid */}
      <section className="pb-32 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {articles.map((article, index) => (
              <article
                key={index}
                className="bg-[#FBF8F3] border border-[#E7E1D9] p-8 group hover:border-[#F97700] transition-all duration-300 cursor-pointer"
              >
                <p className="text-xs font-semibold tracking-[0.2em] uppercase text-[#F97700] mb-4">
                  {article.category}
                </p>
                <h2 className="text-xl font-semibold text-[#0B0B0B] leading-tight mb-4 group-hover:text-[#F97700] transition-colors">
                  {article.title}
                </h2>
                <p className="text-[#2E2E2E] leading-relaxed mb-6 text-sm">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-sm text-[#2E2E2E]">
                  <span>{article.date}</span>
                  <span>{article.readTime}</span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-32 px-6 bg-[#0B0B0B]">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-semibold text-white leading-tight mb-8">
            {t('cta.title')}
          </h2>
          <p className="text-lg text-white/80 mb-12 max-w-2xl mx-auto">
            {t('cta.subtitle')}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/diagnostico"
              className="inline-flex items-center justify-center px-8 py-4 bg-[#F97700] text-white font-semibold hover:bg-[#E56E00] transition-colors whitespace-nowrap cursor-pointer"
            >
              {t('cta.primary')}
            </Link>
            <a
              href="https://wa.me/5511930322408"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center px-8 py-4 bg-white text-[#0B0B0B] font-semibold hover:bg-white/90 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              {t('cta.secondary')}
            </a>
          </div>
        </div>
      </section>

    </div>
  );
}
